import {customEvent} from "../../../webpack/modules/events";
import {trackProductPageGa4Events} from "../../../webpack/modules-optimized/product";

customEvent('show.bs.collapse', '#product-page .pi-options', false, function(element, event) {
    if (!event.target.classList.contains('pi-options')) return;
    let id = element.id;
    let productIndex = element.dataset.productIndex;
    let eventData = productIndex;
    let modelOption = element.querySelector('.options[data-type="model"]');

    document.querySelectorAll('.pi-options-select').forEach((button) => button.classList.remove('bg-black', 'text-white'));
    document.querySelector('.pi-options-select[data-bs-target="#'+id+'"]').classList.add('bg-black', 'text-white');
    if (modelOption) eventData = modelOption.dataset.modelsType+'_'+productIndex;
    trackProductPageGa4Events('SwitchMultiProduct', eventData);
});